import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Modal, Form, InputNumber, Card, message, Row } from 'antd';
import { projectionRequests } from '../../requests';
import { validateCurrency } from '../../utils/validation';
import { getFormattedDouble } from '../../utils/format';

const EditProjection = ({ month, year, type, projectionValue, setProjectionValue }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const fetchData = async (newMonth, newYear, newType) => {
    const response = await projectionRequests.getByMonthAndYear(newMonth, newYear, newType);
    setProjectionValue(response.data.value);
  }

  useEffect(() => {
    fetchData(month, year, type);
  }, [month, year, type]);

  const handleUpdateClick = () => {
    // Open modal and pre-fill the form with the current value
    form.setFieldsValue({ projection_value: projectionValue?.toString().replace('.', ',') });
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      const projectionDto = {
        type,
        month,
        year,
        value: parseFloat(values.projection_value.replace(',', '.')),
      };
      const response = await projectionRequests.create(projectionDto);
      setProjectionValue(response.data.value);
      message.success('Projection updated successfully');
      setIsModalVisible(false);
    } catch (error) {
      message.error('Error updating projection');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button type="primary" onClick={handleUpdateClick}>
        Editar projeção
      </Button>
      <Modal
        title="Atualizar projeção"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            name="projection_value"
            label="Nova projeção"
            rules={[
              { required: true, message: 'Campo obrigatório!' },
              { validator: validateCurrency },
            ]}
          >
            <Input style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Salvar
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EditProjection;
